import ContentfulApi from 'api/Contentful';
import { DEFAULT_LOCALE } from 'constants/locales';
import Log from 'utils/Log';

import { CONTENTFUL_OPERATIONS, CONTENTFUL_QUERIES, CONTENTFUL_PARAMS } from './constants';

class ContentfulStoreLocation {
  /**
   * Fetch store location collection based on query variables
   *
   * @param {Object} queryVariables
   * @returns {Array} of objects with store location information
   */
  static async fetchStoreLocationCollection(queryVariables = {}) {
    const query = CONTENTFUL_QUERIES.STORE_LOCATION_COLLECTION;
    const operationName = CONTENTFUL_OPERATIONS.STORE_LOCATION_COLLECTION;
    const { locale, order, where } = queryVariables;
    let storeLocationArray = [];
    let apiResponse;
    let result = [];

    try {
      apiResponse = await ContentfulApi.call({
        query,
        variables: {
          locale: locale || DEFAULT_LOCALE,
          order: order || CONTENTFUL_PARAMS.ORDER_SORT_NAME_ASC,
          where: where || {
            enabled: true,
          },
        },
      });

      storeLocationArray = apiResponse[operationName]?.items;

      if (storeLocationArray?.length > 0) {
        result = storeLocationArray;
      } else {
        throw new Error(`operation ${operationName} not found on response`);
      }
    } catch (error) {
      Log.warn(
        `ContentfulStoreLocation:fetchStoreLocationCollection - no results - message: ${error.message}`,
        error
      );
    }

    return result;
  }
}

export default ContentfulStoreLocation;
